<template>
  <v-card outlined style="margin-bottom: 24px" v-if="profile && profile.student">
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Thông tin ticket</h5>
    </div>

    <v-row class="px-6 pb-6" no-gutters>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Họ tên</p>
        <p class="my-0">{{ profile.student.name }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Mã HS</p>
        <p class="my-0">{{ profile.student.code_short }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Loại phí</p>
        <p class="my-0">
          {{ profile.category | getCategory }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" icon class="ml-1" color="primary" @click="openBillDetail">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span class="white--text">Xem chi tiết hoá đơn</span>
          </v-tooltip>
        </p>
      </v-col>
      <v-col cols="3" class="">
        <p class="grey--text mb-0 mt-0 d-flex align-items-center">
          Người hỗ trợ
          <v-btn icon x-small @click="openDialog" class="ml-1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
        </p>
        <p class="my-0">{{ inChargeNames }}</p>
      </v-col>
    </v-row>
    <StuTicketInCharge
      :dialog="dialog"
      @inputConfirmed="update"
      @closeDialog="dialog = false"
      :profile="profile"
      @refresh="refresh"
    />
    <DetailBillDialog ref="detail-bill-dialog" />
  </v-card>
</template>

<script>
import StuTicketInCharge from './StuTicketInCharge.vue'
import DetailBillDialog from '../tuitionFee/detail-period/action/DetailBillDialog.vue'
import { mapActions } from 'vuex'
export default {
  props: { profile: Object },
  components: { StuTicketInCharge, DetailBillDialog },
  data() {
    return {
      updateLeadDialog: false,
      dialog: false
    }
  },
  computed: {
    inChargeNames() {
      if (this.profile.inCharge && this.profile.inCharge.length > 0) {
        return this.profile.inCharge.map(person => person.name || person.username).join(', ')
      } else {
        return '--'
      }
    }
  },
  methods: {
    ...mapActions('studentTickets', ['getOneStudentTicket', 'updateStudentTicket']),
    ...mapActions('ticketLog', ['fetchLogs']),
    ...mapActions('ticketMessage', ['fetchStudentTicketMessages']),
    ...mapActions({
      setReport: 'tuitionFeeReport/setReport',
      fetchPeriod: 'tuitionFeePeriod/fetchPeriod'
    }),

    async update(data) {
      this.$loading.active = true
      try {
        await this.updateStudentTicket({ id: this.profile.id, ...data })

        this.$alert.success('Đã cập nhập trạng thái thành công')
        this.dialog = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
        this.$loading.active = false
      }
    },

    openDialog() {
      this.dialog = true
    },

    openFinish() {
      this.finishDialog = true
    },
    closeFinish() {
      this.finishDialog = false
    },
    refresh() {
      this.$emit('refresh')
    },
    async openBillDetail() {
      await this.fetchPeriod(this.profile.period.id)
      this.setReport(this.profile.report)
      this.$refs['detail-bill-dialog'].openDialog(this.profile.category)
    }
  },
  filters: {
    getCategory(cate) {
      switch (cate) {
        case 'cen':
          return 'Học phí'
        case 'decen':
          return 'Thu hộ, chi hộ'
        case 'all':
          return 'Tất cả'
        default:
          return '--'
      }
    }
  }
}
</script>
